export function getFontColorByHex(h) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  let count = 0;
  if (r < 100) count++;
  if (g < 100) count++;
  if (b < 100) count++;

  return count > 1 ? "#FFFFFF" : "#000";
}

export function isDark(h, threshold = 100) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  let count = 0;
  if (r < threshold) count++;
  if (g < threshold) count++;
  if (b < threshold) count++;

  return count > 1 ? true : false;
}

export function hexToRGB(h) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return { r: r, g: g, b: b };
}

export function hexToTransparentRGB(h) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, 0.2)`;
}

export function hexToRGBWithAlpha(h, alpha) {
  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (h.length === 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

    // 6 digits
  } else if (h.length === 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
}

export function getDarkerColor(h1, h2) {
  let rgbh1 = hexToRGB(h1);
  let rgbh2 = hexToRGB(h2);

  rgbh1 = { r: (rgbh1.r / 255) * 100, g: (rgbh1.g / 255) * 100, b: (rgbh1.b / 255) * 100 };
  rgbh2 = { r: (rgbh2.r / 255) * 100, g: (rgbh2.g / 255) * 100, b: (rgbh2.b / 255) * 100 };

  const percentageh1 = Math.round((rgbh1.r + rgbh1.g + rgbh1.b) / 3);
  const percentageh2 = Math.round((rgbh2.r + rgbh2.g + rgbh2.b) / 3);

  // darker color gives lower %
  const result = percentageh1 - percentageh2;

  if (result < 0) {
    return h1;
  } else {
    return h2;
  }
}
